import { FormGroup } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import { useFormValues } from '@s20/components/forms/FormContext';
import { httpClient } from '@s20/services/httpClient';
import { getJobStartTime, getTzAbbreviation, JobAssignmentCancellationType } from '../../../../../dispatch/Dispatch';
import ValidatedSelect from '../../../../../common/forms/ValidatedSelect';
import { ApiRoutes } from '../../../../../Common';
import { toContactDropdownOption } from '../../../../../job/Job';
import Input from '../../../../../common/forms/Input';
import { FormCheckbox, Textarea } from '../../../../../common/forms/FormElements';

export const CancelJobBody = ({
    jobCancellationReasons, jobCancellationTypes, day, job,
}) => {
    const values = useFormValues();
    const { expandedCancellationReasonRequired, id } = job || {};

    const { data: companyContacts, isLoading: companyContactsLoading } = useQuery({
        queryKey: ['locationContactsForJob', id],
        queryFn: () => httpClient.post(ApiRoutes.locationContact.forJob(id)),
        enabled: expandedCancellationReasonRequired,
        select: (allCompanyContacts) => allCompanyContacts.map((lc) => toContactDropdownOption(lc)),
    });

    return (
        <>
            <FormGroup>
                <label>
                    {`Job Start Time: ${getJobStartTime({ day, job })}`}
                </label>
            </FormGroup>

            <ValidatedSelect
                placeholder="Select Cancellation Type"
                id="selectedJobCancellationType"
                name="selectedJobCancellationType"
                label="Cancellation Type"
                isClearable={false}
                required
                options={jobCancellationTypes}
                error="A cancellation type is required"
            />

            <ValidatedSelect
                placeholder="Select Cancellation Reason"
                id="selectedJobCancellationReasonType"
                name="selectedJobCancellationReasonType"
                label="Cancellation Reason"
                isClearable={false}
                required
                options={jobCancellationReasons.filter((reason) =>
                    // reason.id refers to the job cancellation type id
                    // reason.value refers to the actual reason type id
                    reason.id == values.selectedJobCancellationType,
                )}
                error="A cancellation reason is required"
            />

            {expandedCancellationReasonRequired && values.selectedJobCancellationType == JobAssignmentCancellationType.ClientCancel && (
                <ValidatedSelect
                    isClearable={false}
                    id="cancelContactId"
                    name="cancelContactId"
                    label="Cancel Requested By"
                    required
                    valueField="id"
                    options={companyContacts}
                    getOptionLabel={(locationContact) => locationContact.contactName}
                    getOptionValue={(locationContact) => locationContact.id}
                    error="Please select who requested this cancellation"
                    isLoading={companyContactsLoading}
                />
            )}

            <Input
                label="Cancellation Time"
                id="selectedJobCancellationTime"
                required
                type="datetime-local"
                name="selectedJobCancellationTime"
                error="Cancellation Time is required."
                endAddonClassName="inset"
                endAddon={(
                    <span className="text-muted">
                        {getTzAbbreviation({ day, job })}
                    </span>
                )}
            />

            <FormCheckbox
                small
                id="isCrewOnSiteAndWorkPerformed"
                name="isCrewOnSiteAndWorkPerformed"
                labelText="Crew arrived on site and performed work"
                className="mb-2"
            />

            <Textarea
                label="Notes"
                id="notes"
                name="selectedJobCancellationNotes"
                placeholder="Enter optional notes regarding the cancellation."
                maxLength="500"
                rows="5"
            />
        </>
    );
};